<app-header></app-header>
<section id="retalk-int" class="bg-grey reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

        <div class="row">
            <div class="col-lg-12 head-tit">
                <p class="rco fw-bold mb-0" [innerHTML]="podcast.subtitle"></p>
                <h1 [innerHTML]="podcast.title"></h1>

            </div>
        </div>

        <div class="row equipo-int-blq">



            <div class="col-12 mb-4">
                <div class="container-vimeo">
                    <iframe *ngIf="podcast.podUrl" [src]="videoURI" width="1920" height="1080"
                        title="retailCo. Damos vida a los locales" frameborder="0" webkitallowfullscreen
                        mozallowfullscreen allowfullscreen class="videoTranslate"></iframe>

                </div>

            </div><!-- fin audio player-->

            <div class="col-lg-12 social-btn-blq">
                <div class="col-2" style="width: 180px;">
                    <div class="sa-social">
                        <div class="sa-share-text">
                            <span>Compartir&nbsp;
                                <svg width="30" height="30" viewBox="0 0 23 23" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M21.0853 5.27276C21.0853 3.41924 19.5836 1.91666 17.7311 1.91666C15.8786 1.91666 14.3769 3.41924 14.3769 5.27276C14.3769 5.67508 14.4477 6.06086 14.5774 6.41833L8.07984 9.65646C7.48093 8.74045 6.44656 8.13525 5.27091 8.13525C3.41846 8.13525 1.91675 9.63783 1.91675 11.4914C1.91675 13.3449 3.41846 14.8475 5.27091 14.8475C6.44696 14.8475 7.48164 14.2419 8.08045 13.3253L14.582 16.5692C14.4493 16.9302 14.3769 17.3202 14.3769 17.7272C14.3769 19.5807 15.8786 21.0833 17.7311 21.0833C19.5836 21.0833 21.0853 19.5807 21.0853 17.7272C21.0853 15.8737 19.5836 14.3711 17.7311 14.3711C16.6283 14.3711 15.6498 14.9036 15.0385 15.7256L8.4848 12.4549C8.57606 12.1497 8.62508 11.8263 8.62508 11.4914C8.62508 11.1558 8.57585 10.8317 8.48422 10.5259L15.0298 7.26265C15.6406 8.09132 16.6231 8.62887 17.7311 8.62887C19.5836 8.62887 21.0853 7.12629 21.0853 5.27276ZM15.3353 17.7272C15.3353 16.4033 16.4079 15.33 17.7311 15.33C19.0543 15.33 20.1269 16.4033 20.1269 17.7272C20.1269 19.0512 19.0543 20.1244 17.7311 20.1244C16.4079 20.1244 15.3353 19.0512 15.3353 17.7272ZM5.27091 9.09414C3.94773 9.09414 2.87508 10.1674 2.87508 11.4914C2.87508 12.8153 3.94773 13.8886 5.27091 13.8886C6.5941 13.8886 7.66675 12.8153 7.66675 11.4914C7.66675 10.1674 6.5941 9.09414 5.27091 9.09414ZM15.3353 5.27276C15.3353 3.94882 16.4079 2.87554 17.7311 2.87554C19.0543 2.87554 20.1269 3.94882 20.1269 5.27276C20.1269 6.59671 19.0543 7.66998 17.7311 7.66998C16.4079 7.66998 15.3353 6.59671 15.3353 5.27276Z"
                                        fill="#333333" />
                                </svg>
                            </span>
                        </div>
                        <ul class="sa-share-buttons">
                            <li><a (click)="shareOnFacebook()" title="Compartir en facebook" target="_blank"><svg
                                        enable-background="new 0 0 32 32" height="32px" class="social" version="1.0"
                                        viewBox="0 0 32 32" width="32px" xml:space="preserve"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path
                                            d="M18,32V18h6l1-6h-7V9c0-2,1.002-3,3-3h3V0c-1,0-3.24,0-5,0c-5,0-7,3-7,8v4H6v6h6v14H18z">
                                        </path>
                                    </svg></a></li>
                            <li><a (click)="shareOnLinkedin()" target="_blank" title="Compartir en Linkedin">
                                    <svg width="32px" height="32px" viewBox="0 0 32 32">
                                        <path
                                            d="M.404 30.586h6.862V9.954H.404v20.632zM3.834 7.137h-.046C1.488 7.137 0 5.547 0 3.57 0 1.544 1.536 0 3.878 0c2.348 0 3.794 1.543 3.836 3.57 0 1.977-1.488 3.567-3.88 3.567M32 30.586h-6.86v-11.04c0-2.772-.992-4.668-3.476-4.668-1.892 0-3.024 1.282-3.52 2.512-.182.442-.226 1.056-.226 1.672v11.524H11.06s.088-18.7 0-20.632h6.858v2.922c.914-1.408 2.542-3.408 6.184-3.408 4.512 0 7.898 2.95 7.898 9.29v11.828z">
                                        </path>
                                    </svg></a></li>

                        </ul>
                    </div>
                </div>
            </div>


            <!-- Tu componente Angular HTML -->
            <!-- <button (click)="shareOnFacebook()" class="facebook-share-button">
                <i class="fab fa-facebook-square"></i> Compartir en Facebook
            </button>
            <button (click)="shareOnLinkedin()" class="facebook-share-button">
                <i class="fab fa-linkedin"></i> Compartir en Linkedin
            </button> -->






            <div class="col-lg-8 rt-quote mb-5">
                <h2 class="fw-bold rco" *ngIf="podcast.title_orange" [innerHTML]="podcast.title_orange"></h2>

                <q *ngIf="podcast.mainText" [innerHTML]="podcast.mainText"></q>
                <span class="fw-bold grey" *ngIf="podcast.author" [innerHTML]="podcast.author"></span>

            </div> <!-- fin quote-->
            <div class="col-lg-8 rt-quote mb-5">
                <q *ngIf="podcast.secondText" [innerHTML]="podcast.secondText"></q>
                <span class="fw-bold grey" *ngIf="podcast.author2" [innerHTML]="podcast.author2"></span>

            </div> <!-- fin quote-->
            <div class="col-lg-8 rt-quote mb-5">
                <q *ngIf="podcast.thirdText" [innerHTML]="podcast.thirdText"></q>
                <span class="fw-bold grey" *ngIf="podcast.author3" [innerHTML]="podcast.author3"></span>

            </div> <!-- fin quote-->
            <div class="col-lg-8 rt-quote mb-5">
                <q *ngIf="podcast.fourText" [innerHTML]="podcast.fourText"></q>
                <span class="fw-bold grey" *ngIf="podcast.author4" [innerHTML]="podcast.author4"></span>

            </div> <!-- fin quote-->
            <div class="col-lg-8 rt-quote mb-5">
                <q *ngIf="podcast.fiveText" [innerHTML]="podcast.fiveText"></q>
                <span class="fw-bold grey" *ngIf="podcast.author5" [innerHTML]="podcast.author5"></span>

            </div> <!-- fin quote-->


        </div>

        <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 col-12 prev-next">

                <div class="prev-next-blq">
                    <!--activar clase inactiv cuando no haya ningún elemento más adelante o detrás-->
                    <a [ngClass]="{'inactiv': !id_prev}"
                        [routerLink]="id_prev ? ['/retalk/', id_prev] : null"><span>Anterior</span>
                    </a>
                    <a [ngClass]="{'inactiv': !id_next}"
                        [routerLink]="id_next ? ['/retalk/', id_next]: null"><span>Siguiente</span></a>

                </div>


            </div>

        </div>



    </div><!-- fin container-->

</section>

<app-footer-main></app-footer-main>